var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('q-select',{attrs:{"autocomplete":"off","options":_vm.options,"option-value":"code","option-label":"name","use-input":"","input-debounce":"10","label":"Country"},on:{"filter":_vm.findName,"input":_vm.selectChanged},model:{value:(_vm.selectedOption),callback:function ($$v) {_vm.selectedOption=$$v},expression:"selectedOption"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }